export function getAppName () {
  let params = new URLSearchParams(window.location.search)
  // keep old `is_wechat` beahvior for backward compatibility
  if (params.get('is_wechat')) {
    return 'photo-auth-mp'
  }

  let appName = params.get("app_name")
  if (appName) {
    return appName
  }
  // return default app name.
  return 'photo-auth'
}